const SUGGESTED_STATUS = 'SUGGESTED'
const APPROVED_STATUS = 'APPROVED'
const DISAPPROVED_STATUS = 'DISAPPROVED'

const SUGGESTED_LABEL = 'Pendente'
const DISAPPROVED_LABEL = 'Rejeitado'

const STATUSES = {
  [SUGGESTED_STATUS]: SUGGESTED_STATUS,
  [APPROVED_STATUS]: APPROVED_STATUS,
  [DISAPPROVED_STATUS]: DISAPPROVED_STATUS,
}

const STATUSES_LABEL = {
  [SUGGESTED_STATUS]: SUGGESTED_LABEL,
  [DISAPPROVED_STATUS]: DISAPPROVED_LABEL,
}

const STATUSES_TABS = [
  { value: 'all', label: 'Todos' },
  { value: SUGGESTED_STATUS, label: SUGGESTED_LABEL },
  { value: DISAPPROVED_STATUS, label: DISAPPROVED_LABEL },
]

export default {
  APPROVED_STATUS,
  DISAPPROVED_STATUS,
  STATUSES_LABEL,
  STATUSES_TABS,
  STATUSES,
  SUGGESTED_STATUS,
}
